@if (obser$ | async; as obser) {
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
    <form-wrapper>
      <ng-container formArrayName="owners">
        <div class="row">
          @for (owner of owners.controls; track owner; let index = $index) {
            <ng-container [formGroup]="owner">
              <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
                @if (owners.length > 1) {
                  <div ngClass="{{ index == 0 ? 'tap-main' : 'tap-spouse' }}">
                    <span class="tap-text">
                      {{ owner.get('userFirstName')?.value }}
                      {{ owner.get('userLastName')?.value }}
                    </span>
                  </div>
                }
                <ng-container [formGroup]="owner.get('documents')">
                  <pr-input label="Type de document" [derrors]="derrors">
                    <mat-select formControlName="document">
                      @for (type of typeDocument; track type) {
                        <mat-option [value]="type.code">
                          {{ type.label }}
                        </mat-option>
                      }
                    </mat-select>
                  </pr-input>
                  @if (
                    owner?.get('documents')?.get('document')?.value === 'CNI'
                  ) {
                    <pr-input
                      label="Numéro de la carte d’identité"
                      [derrors]="derrors"
                    >
                      <input formControlName="cniNumber" type="text" />
                    </pr-input>
                  }
                  <pr-input-date
                    [hidden]="
                      !documentTypes.includes(
                        owner?.get('documents')?.get('document')?.value
                      )
                    "
                    formControlName="dateExpired"
                    label="Date d'expiration"
                    [derrors]="derrors"
                  ></pr-input-date>
                  @if (
                    owner?.get('documents')?.get('document')?.value === 'CNI'
                  ) {
                    <info [option]="{ icon: 'info' }"
                      >La copie de la carte d’identité nécessite 2 fichiers en
                      couleurs : le recto et le verso.</info
                    >
                  }
                  @if (certif) {
                    <div class="row mt">
                      <div class="col-md-12">
                        <pr-color-panel
                          [display]="
                            verificationResults[owner?.get('ownerId')?.value]
                              ?.display
                          "
                        >
                          <pr-panel-body clazz="pam">
                            <pr-label
                              [name]="
                                verificationResults[owner.get('ownerId').value]
                                  ?.icon
                              "
                              [width]="18"
                              [height]="18"
                              >{{
                                verificationResults[owner.get('ownerId').value]
                                  ?.text
                              }}</pr-label
                            >
                          </pr-panel-body>
                        </pr-color-panel>
                      </div>
                    </div>
                  }
                  <div class="row">
                    <div class="col-md-12 mt">
                      @if (!owner?.get('documents')?.get('id')?.value) {
                        <pr-file
                          (fileChange)="
                            onLoadFiles($event, owner?.get('ownerId').value)
                          "
                          [form]="true"
                          [fileForm]="file"
                          [gedAccountId]="entity?.accountId"
                          [gedDocuments]="gedDocuments"
                          [gedOwnerId]="owner?.get('ownerId')?.value"
                          (gedDocumentSelected)="
                            onGedDocumentSelected(
                              $event,
                              index,
                              owner?.get('ownerId')?.value
                            )
                          "
                        ></pr-file>
                      }
                      @if (owner?.get('documents')?.get('id')?.value) {
                        <ged-document-card
                          [doc]="ownerDocument(index)"
                          [accountId]="entity?.accountId"
                          [documents]="gedDocuments"
                          [ownerId]="owner?.get('ownerId')?.value"
                          (pick)="
                            onGedDocumentSelected(
                              $event,
                              index,
                              owner?.get('ownerId')?.value
                            )
                          "
                          (withdraw)="withdraw(index)"
                          (remove)="
                            deleteDocument(
                              owner?.get('documents')?.value,
                              index,
                              owner?.get('ownerId')?.value
                            )
                          "
                        ></ged-document-card>
                      }
                    </div>
                  </div>
                </ng-container>
                <div
                  style="max-height: none; margin-top: 1rem; position: relative"
                >
                  <div>
                    @if (displayDocumentLoading) {
                      <pr-loader
                        style="max-height: 0rem; margin-top: 7rem"
                      ></pr-loader>
                    }
                  </div>
                  @if (iframeUrls?.[index]) {
                    <iframe
                      [src]="iframeUrls?.[index]"
                      width="100%"
                      height="700"
                      frameborder="0"
                    ></iframe>
                  }
                </div>
              </div>
            </ng-container>
          }
        </div>
      </ng-container>
    </form-wrapper>
    @if (error) {
      <div class="alert alert-danger" style="margin-top: 20px" role="alert">
        {{ error }}
      </div>
    }
    <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
  </form>
} @else {
  <pr-loader></pr-loader>
}
@if (docLoading) {
  <pr-loader></pr-loader>
}
